import Vue from 'vue';

const settingsRepository = {
  get: () => Vue.$axios.get(`settings`)
  .then(({data}) => data, (error) => console.log(error)),

  update: (authMethod, whatsappAuthAccountId, notificationMethod, whatsappNotificationAccountId, customerCategoriesWithoutNotifications, authMessage) => {
    let data = new FormData();

    data.append('authMethod', authMethod);
    data.append('authMessage', authMessage);
    data.append('whatsappAuthAccountId', whatsappAuthAccountId);

    if (notificationMethod)
      data.append('notificationMethod', notificationMethod);
    if (whatsappNotificationAccountId)
      data.append('whatsappNotificationAccount', whatsappNotificationAccountId);
    if (customerCategoriesWithoutNotifications) {
      data.append('customerCategoriesWithoutNotifications', customerCategoriesWithoutNotifications);
    }

    return Vue.$axios.post('settings/update', data)
    .then((data) => data);
  },
};

export default settingsRepository;
